// extracted by mini-css-extract-plugin
module.exports = {"HeaderCatalog":"style_HeaderCatalog__13X1V","Wrapper":"style_Wrapper__RMwGj"};